import softwareImage from '../../assets/images/Software.png';  

const data = [
  {
    imageUrl: softwareImage, 
    title: "Full software development outsourcing",
    description:  "We assemble fully managed development teams to implement software projects end to end. Our team takes 100% responsibility  for project planning, collaboration and risk management. you get top quality software promptly and at a 1.5 - 2.5x lower cost"
  },
  {
    imageUrl: softwareImage,
    title: "Dedicated teams",
    description:  "We compose dedicated teams with all necessary competencies to take over particular tasks (e.g., coding, QA, integration). With a high-performing team focused solely on your project, you can efficiently address skill gaps and speed up development.",
   
  },
];

export default data;
